import { combineReducers } from 'redux';
import reduceReducers from 'reduce-reducers';
import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';
import changeValueReducerFactory from '@nhl/change-value-reducer-factory';

import { clearErrorsOnActionTypeReducerFactory, clearLoadingStateOnActionReducerFactory } from '../../utils';
import actionTypes from './actionTypes';
import formTypes from './formTypes';

/* State Shape
entry: {
    entryState: {
        form: String,
        email: String,
        password: String,
        firstName: String,
        lastName: String,
        title: String,
        affiliation: String,
        nhlContact: String,
    },
    loadingState: {
        isLoading: bool,
        success: bool,
        errors: Array
    }
}
*/

const loadingStateReducer = loadingStateReducerFactory(
    actionTypes.REQUEST_LOGIN,
    actionTypes.REQUEST_FORGOT_PASSWORD,
    actionTypes.REQUEST_ACCOUNT_REQUEST
)(
    actionTypes.LOGIN_RESPONSE,
    actionTypes.FORGOT_PASSWORD_RESPONSE,
    actionTypes.ACCOUNT_REQUEST_RESPONSE
);

const enhancedLoadingStateReducer = reduceReducers(loadingStateReducer, clearErrorsOnActionTypeReducerFactory(actionTypes.CHANGE_VALUE),
    clearLoadingStateOnActionReducerFactory(actionTypes.DISPLAY_FORM));

const formReducer = (state = formTypes.LOGIN, action) => {
    if (action.type === actionTypes.DISPLAY_FORM) {
        return action.payload.form;
    }

    return state;
};

const firstNameReducer = changeValueReducerFactory('')(actionTypes.CHANGE_VALUE, 'firstName', actionTypes.RESET_VALUES, 'formData');
const lastNameReducer = changeValueReducerFactory('')(actionTypes.CHANGE_VALUE, 'lastName', actionTypes.RESET_VALUES, 'formData');
const titleReducer = changeValueReducerFactory('')(actionTypes.CHANGE_VALUE, 'title', actionTypes.RESET_VALUES, 'formData');
const mediaAffiliationReducer = changeValueReducerFactory('')(actionTypes.CHANGE_VALUE, 'mediaAffiliation', actionTypes.RESET_VALUES, 'formData');
const emailReducer = changeValueReducerFactory('')(actionTypes.CHANGE_VALUE, 'email', actionTypes.RESET_VALUES, 'formData');
const passwordReducer = changeValueReducerFactory('')(actionTypes.CHANGE_VALUE, 'password', actionTypes.RESET_VALUES, 'formData');
const nhlContactReducer = changeValueReducerFactory('')(actionTypes.CHANGE_VALUE, 'nhlContact', actionTypes.RESET_VALUES, 'formData');

const entryReducer = combineReducers({
    form: formReducer,
    firstName: firstNameReducer,
    lastName: lastNameReducer,
    title: titleReducer,
    mediaAffiliation: mediaAffiliationReducer,
    email: emailReducer,
    password: passwordReducer,
    nhlContact: nhlContactReducer,
});

const reducer = combineReducers({
    entryState: entryReducer,
    loadingState: enhancedLoadingStateReducer,
});

export default reducer;